import { WEBGL } from 'three/examples/jsm/WebGL.js';
import { Viewer } from './viewer.js';
import { SimpleDropzone } from 'simple-dropzone';
// import { ValidationController } from './validation-controller.js';
import queryString from 'query-string';

if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
  console.error('The File APIs are not fully supported in this browser.');
} else if (!WEBGL.isWebGLAvailable()) {
  console.error('WebGL is not supported in this browser.');
}

class App {

  /**
   * @param  {Element} el
   * @param  {Location} location
   */
  constructor (el, location) {
    const hash = location.hash ? queryString.parse(location.hash) : {};
    
    this.options = {
      kiosk: Boolean(hash.kiosk),
      model: hash.model, // 6912
      preset: hash.preset || '',
      cameraPosition: hash.cameraPosition
        ? hash.cameraPosition.split(',').map(Number)
        : null
    };

    this.el = el;
    this.viewer = null;
    this.viewerEl = null;
    this.spinnerEl = el.querySelector('.loading-screen');
    this.dropEl = el.querySelector('.dropzone');
    this.inputEl = el.querySelector('#file-input');
    // this.validationCtrl = new ValidationController(el);

    this.createDropzone();
    this.showSpinner();

    const options = this.options;

    this.load(hash.model ? `https://api.babby.xyz/file/${hash.model}` : 'https://idk.mypinata.cloud/ipfs/QmYQQX6p9aJLSTWN7oAGv4DxNhGG9j8vkaMmT7asgiqHWN') // 'https://api.babby.xyz/file/1')
    // this.load(hash.model ? `https://idk.mypinata.cloud/ipfs/QmZT6ugG9Pnsdx1zJsxPjunJh1Ym5DRGn8DYoqQJAESdwM/${hash.model}.glb` : 'https://idk.mypinata.cloud/ipfs/QmZT6ugG9Pnsdx1zJsxPjunJh1Ym5DRGn8DYoqQJAESdwM/1.glb')
  }


  /**
   * Sets up the drag-and-drop controller.
   */
  createDropzone () {
    const dropCtrl = new SimpleDropzone(this.dropEl, this.inputEl);
    dropCtrl.on('drop', ({files}) => this.loadFromDrop(files));
    dropCtrl.on('dropstart', () => this.showSpinner());
    dropCtrl.on('droperror', () => this.hideSpinner());
  }

  /**
   * Sets up the view manager.
   * @return {Viewer}
   */
  createViewer () {
    this.viewerEl = document.createElement('div');
    this.viewerEl.classList.add('viewer');
    this.dropEl.innerHTML = '';
    this.dropEl.appendChild(this.viewerEl);
    this.viewer = new Viewer(this.viewerEl, this.options);
    return this.viewer;
  }

  /**
   * Loads a fileset provided from URL.
   * @param  {Map<string, File>} file
   */
  load (file) {
    this.view(file);
  }

   /**
   * Loads a fileset provided by user action.
   * @param  {Map<string, File>} fileMap
   */
  loadFromDrop (fileMap) {
    let rootFile;
    let rootPath;
    Array.from(fileMap).forEach(([path, file]) => {
      if (file.name.match(/\.(gltf|glb)$/)) {
        rootFile = file;
        rootPath = path.replace(file.name, '');
      }
    });

    if (!rootFile) {
      this.onError('No .gltf or .glb asset found.');
    }

    this.viewFromDrop(rootFile, rootPath, fileMap);
  }

  /**
   * Passes a model to the viewer, given file and resources.
   * @param  {File|string} rootFile
   * @param  {string} rootPath
   * @param  {Map<string, File>} fileMap
   */
  view (file) {

    if (this.viewer) this.viewer.clear();

    const viewer = this.viewer || this.createViewer();

    // Set a timer that sets hasFinishedLoading to true after 2000ms
    let hasFinishedLoading = false;
    const timer = setTimeout(() => {
      hasFinishedLoading = true;
    }, 4000);
    
    viewer
      .load(file)
      .catch((e) => this.onError(e))
      .then((gltf) => {
          this.hideSpinner();
       });
  }

  /**
   * Passes a model to the viewer, given file and resources.
   * @param  {File|string} rootFile
   * @param  {string} rootPath
   * @param  {Map<string, File>} fileMap
   */
  viewFromDrop (rootFile, rootPath, fileMap) {

    if (this.viewer) this.viewer.clear();

    const viewer = this.viewer || this.createViewer();

    const fileURL = typeof rootFile === 'string'
      ? rootFile
      : URL.createObjectURL(rootFile);

    const cleanup = () => {
      this.hideSpinner();
      if (typeof rootFile === 'object') URL.revokeObjectURL(fileURL);
    };

    viewer
      .load(fileURL, rootPath, fileMap)
      .catch((e) => this.onError(e))
      .then((gltf) => {
        // if (!this.options.kiosk) {
        //   this.validationCtrl.validate(fileURL, rootPath, fileMap, gltf);
        // }
        cleanup();
      });
  }

  /**
   * @param  {Error} error
   */
  onError (error) {
    let message = (error||{}).message || error.toString();
    if (message.match(/ProgressEvent/)) {
      message = 'Unable to retrieve this file. Check JS console and browser network tab.';
    } else if (message.match(/Unexpected token/)) {
      message = `Unable to parse file content. Verify that this file is valid. Error: "${message}"`;
    } else if (error && error.target && error.target instanceof Image) {
      message = 'Missing texture: ' + error.target.src.split('/').pop();
    }
    console.error(error);
  }

  showSpinner () {
    this.spinnerEl.classList.remove('hidden');
  }

  hideSpinner () {
    this.spinnerEl.classList.add('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const app = new App(document.body, location);
});
